import { render, staticRenderFns } from "./UserTypeDisplay.vue?vue&type=template&id=abf33546&scoped=true&"
import script from "./UserTypeDisplay.vue?vue&type=script&lang=js&"
export * from "./UserTypeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf33546",
  null
  
)

export default component.exports